import { render, staticRenderFns } from "./EmailFindPwd.vue?vue&type=template&id=dc0657f4&scoped=true"
import script from "./EmailFindPwd.vue?vue&type=script&lang=js"
export * from "./EmailFindPwd.vue?vue&type=script&lang=js"
import style0 from "./EmailFindPwd.vue?vue&type=style&index=0&id=dc0657f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0657f4",
  null
  
)

export default component.exports